import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29 30.4297H25L20.55 33.3897C19.89 33.8297 19 33.3598 19 32.5598V30.4297C16 30.4297 14 28.4297 14 25.4297V19.4297C14 16.4297 16 14.4297 19 14.4297H29C32 14.4297 34 16.4297 34 19.4297V25.4297C34 28.4297 32 30.4297 29 30.4297Z",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9998 23.3594V23.1494C23.9998 22.4694 24.4198 22.1094 24.8398 21.8194C25.2498 21.5394 25.6598 21.1794 25.6598 20.5194C25.6598 19.5994 24.9198 18.8594 23.9998 18.8594C23.0798 18.8594 22.3398 19.5994 22.3398 20.5194",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9955 25.75H24.0045",
  stroke: "#36354A",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

  interface IProps {
    color?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})